import { createFileRoute } from '@tanstack/react-router'
import { ShoppingBasketIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/orders')({
  staticData: {
    title: 'route.orders',
    crumb: 'route.orders',
    icon: ShoppingBasketIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
